import TabPanel from '@/components/TabPanel/TabPanel';
import ClaimTabContent from '@/features/creditor/claimsTab/claimsTabContent';
import CreditorSummaryHeader from './CreditorSummaryHeader';
import { useParams } from 'react-router-dom';
import CreditiorUpdate from './CreditiorUpdate';
import { useCase } from '@/features/case/use-case';
import CreditorAttributeHistoryTab from '../CreditorHistoryClaims/creditorAttributeHistory';
import { useGetCreditorSummaryHeaderDataQuery } from './CreditorSummaryReducer';
import { MotifProgressLoader } from '@ey-xd/motif-react';
import CreditorDistributions from '../CreditorDistributions';

export default function CreditorSummaryUpdate() {
    const caseData = useCase();
    const parameter = useParams();
    const propData = {
      caseId: caseData.caseId,
      creditorId: parameter.creditorId || ""
  }
    const { data,isLoading} =
      useGetCreditorSummaryHeaderDataQuery(propData);
      const tabPanelData = {
        title: [
        "pages.creditors.creditorUpdate.tabPannelDetails.summary",
         "pages.creditors.creditorUpdate.tabPannelDetails.claims",
         "pages.creditors.creditorView.tabPannelDetails.attributeHistory",
         "pages.creditors.creditorView.tabPannelDetails.distributions"
        ],
        content: [
          <CreditiorUpdate/>, 
          <ClaimTabContent creditorDetails={data}/>, 
          <CreditorAttributeHistoryTab />,
          <CreditorDistributions creditorDetails={data}/>,  
        ]
    
      };
       if (isLoading) {
            return <MotifProgressLoader show variant="default" />;
          }

  return (
    <>
      
      <CreditorSummaryHeader caseId={propData.caseId} creditorId={propData.creditorId || ''}/>
      <div className='ccwp_table_wrapper ccwp_table_dropdown_wrapper mar-b-80'><TabPanel data={tabPanelData} /></div>   
    </>
  )
}
